import React from "react";
import App from "./../app.jsx";

import PagesError from "../pages/error/error.jsx";

//--

import Anasayfa from "../pages/anasayfa";

import SecimAnalizi from "../pages/secim-analizi";
import SokakAnalizi from "../pages/sokak-analizi/index.jsx";
import SandikAnalizi from "../pages/sandik-analizi/index.jsx";
import HaneAnalizi from "../pages/hane-analizi";

import KentmetreRaporu1 from "../pages/kentmetre-raporu/KentmetreRaporu1.jsx";
import KentmetreRaporu2 from "../pages/kentmetre-raporu/KentmetreRaporu2.jsx";
import KentmetreRaporu3 from "../pages/kentmetre-raporu/KentmetreRaporu3.jsx";
import IletisimYonetimi from "../pages/iletisim-yonetimi";
import Kullanicilar from "../pages/kullanicilar/index.jsx";
import Musteriler from "../pages/musteriler/index.jsx";
import GirisYap from "../pages/giris-yap/index.jsx";

import LogKayitlari from "../pages/log-kayitlarıi/index.jsx";
import StratejiHaritasi from "../pages/strateji-haritasi/index.jsx";
import KentmetreHaritasi from "../pages/kentmetre-haritasi/index.jsx";
import HazirRaporlar from "../pages/hazir-raporlar/index.jsx";
import SosyalMedya from "../pages/sosyal-medya/index.jsx";
import AnketVeArastirmalar from "../pages/anket-ve-arastirmalar/index.jsx";
import YuklenenDosyalar from "../pages/yuklenen-dosyalar/index.jsx";
import DinamikPage from "../pages/dinamik-page/index.jsx";
import RaporOlustur from "../pages/rapor-olustur/index.jsx";
import ArastirmaRaporu from "../pages/arastirma-raporu/index.jsx";
import OrnekDosyalar from "../pages/ornek-dosyalar/index.jsx";
import MusteriKullanicilar from "../pages/musteri-kullanicilar/index.jsx";
import Profil from "../pages/profil/index.jsx";
import AfetYonetimi from "../components/AfetYonetimi.jsx";
import DevamEdenAnketler from "../pages/devam-eden-anketler/index.jsx";
import Gorevler from "../pages/gorevler/index.jsx";
import AnketLink from "../pages/anket-link/index.jsx";
import HiyerarsikYapi from "../pages/hiyerarsik-yapi/index.jsx";
import SiyasiAnaliz from "../pages/siyasi-analiz/index.jsx";

const AppRoute = [
  {
    path: "*",
    element: <App />,
    children: [
      { path: "giris-yap", element: <GirisYap /> },
      { path: "*", element: <PagesError /> },
      { path: "404", element: <PagesError /> },
      { path: ":slug", element: <DinamikPage reload={true} /> },
      { path: "anket/:slug", element: <AnketLink /> },
      { id: 51, path: "", removed: true, element: <Anasayfa /> },
      { id: 51, path: "durum-analizi", removed: true, element: <Anasayfa /> },
      {
        id: 295,
        path: "siyasi-analiz",
        removed: true,
        element: <SiyasiAnaliz />,
      },
      {
        id: 48,
        path: "sandik-analizi",
        removed: true,
        element: <SandikAnalizi />,
      },
      {
        id: 24,
        path: "mikro-analizler",
        removed: true,
        element: <HaneAnalizi />,
      },
      {
        id: 23,
        path: "makro-analizler",
        removed: true,
        element: <SokakAnalizi />,
      },
      {
        id: 50,
        path: "secim-analizi",
        removed: true,
        element: <SecimAnalizi />,
      },
      {
        id: 52,
        path: "hazir-raporlar",
        removed: true,
        element: <HazirRaporlar />,
      },
      {
        id: 44,
        path: "strateji-haritasi",
        removed: true,
        element: <StratejiHaritasi />,
      },
      {
        id: 44,
        path: "kentmetre-haritasi",
        removed: true,
        element: <KentmetreHaritasi />,
      },
      {
        id: 73,
        path: "arastirma-raporu",
        removed: true,
        element: <ArastirmaRaporu />,
      },
      {
        id: 71,
        path: "halkla-iletisim-yonetimi",
        removed: true,
        element: <IletisimYonetimi />,
      },
      {
        id: 53,
        path: "tamamlananlar",
        removed: true,
        element: <AnketVeArastirmalar />,
      },
      { id: 66, path: "sosyal-medya", removed: true, element: <SosyalMedya /> },
      {
        id: 72,
        path: "yuklenen-dosyalar",
        removed: true,
        element: <YuklenenDosyalar />,
      },
      {
        id: 74,
        path: "anket-olustur",
        element: <RaporOlustur />,
      },
      {
        id: 92,
        path: "devam-edenler",
        element: <DevamEdenAnketler />,
      },
      {
        id: 83,
        path: "afet-yonetimi",
        element: <AfetYonetimi />,
      },
      {
        id: 94,
        path: "strateji-planlari",
        element: <Gorevler />,
      },
      {
        path: "kentmetre-raporu/*",
        children: [
          { path: "rapor-1", element: <KentmetreRaporu1 /> },
          { path: "rapor-2", element: <KentmetreRaporu2 /> },
          { path: "rapor-3", element: <KentmetreRaporu3 /> },
        ],
      },
      {
        path: "profil",
        removed: true,
        element: <Profil />,
      },
      { path: "hiyerarsik-yapi", element: <HiyerarsikYapi /> },
      { path: "kullanicilar", element: <MusteriKullanicilar /> },
      localStorage.getItem("user") &&
      JSON.parse(localStorage.getItem("user")).role.id === 1
        ? {
            path: "yonetim/*",
            children: [
              { path: "kullanicilar", element: <Kullanicilar /> },
              { path: "musteriler", element: <Musteriler /> },
              { path: "log-kayitlari", element: <LogKayitlari /> },
              { path: "ornek-dosyalar", element: <OrnekDosyalar /> },
            ],
          }
        : {},
    ],
  },
];

export default AppRoute;
